import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-app-style-two',
  templateUrl: './download-app-style-two.component.html',
  styleUrls: ['./download-app-style-two.component.scss']
})
export class DownloadAppStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
